// extracted by mini-css-extract-plugin
module.exports = {"header":"Search_header__3xdBp"};